import HeroBg from "public/cloud-services/hero-section-background.png";

export const HERO_CONSTANTS = {
  title: "Empower Your Business with Scalable Cloud Solutions ",
  desc: "Seamlessly deploy, manage, and optimize your IT infrastructure with OneMind’s cloud infrastructure solutions. Whether you need a private cloud, public cloud, or a POC cloud, OneMind delivers tailored, cloud-based services to accelerate your digital transformation.",
  button: {
    label: "Discover Our Cloud Services! ",
    link: "cloud-services-tab",
  },
  button2: {
    label: "Contact Us",
    link: "contact-us",
  },
  image: HeroBg,
};
